import template from './modalSendAllCards.html';
import controller from './modalSendAllCards.controller';
import './modalSendAllCards.scss';

let modalSendAllCardsComponent = {
  restrict: 'E',
  bindings: {
    request: '<',
    modalState: '<',
    cardCount: '<',
    setAction: '&',
    isMobileApp: '<',
  },
  template,
  controller,
};

export default modalSendAllCardsComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestModal/modalSendAllCards/modalSendAllCards.component.js